import { render, staticRenderFns } from "./ShortTextAttribute.vue?vue&type=template&id=7f43fd93"
import script from "./ShortTextAttribute.vue?vue&type=script&lang=js"
export * from "./ShortTextAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports